module.exports = __webpack_public_path__ + "static/the-autobiography-of-malcolm-x-e093dc7671649c238f69c88acea72807.jpg";